import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { DocumentProps, PageProps, pdfjs } from 'react-pdf';

export const loadReactPdf = () =>
  import('react-pdf').then((mod) => {
    mod.pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
    return mod;
  });

export const loadPdfjs: () => Promise<typeof pdfjs> = () =>
  loadReactPdf().then((mod) => mod.pdfjs);

export const ReactPdfDocument: ComponentType<DocumentProps> = dynamic(
  () => loadReactPdf().then((m) => m.Document),
  {
    ssr: false,
  }
);

export const ReactPdfPage: ComponentType<PageProps> = dynamic(
  () => loadReactPdf().then((m) => m.Page),
  {
    ssr: false,
  }
);
